<template>

  <transition name="fade">
    <div v-if="listLoadingStatus && !isCreationForm || isSubmitLoading" class="common-shadow-loader">
      <Loader/>
    </div>
  </transition>

  <div class="crud-house content-padding">
    <h2>{{ isCreationForm ? 'Добавить' : 'Изменить' }} дом</h2>

    <div v-if="pageNotFound && !isCreationForm" class="house-not-found">Дом с таким номером не найден</div>
    <div v-else class="crud-house-content">
      <div class="crud-house-form">
        <div class="address row">
          <div class="col-12 col-md-8 input-with-cross">
            <input ref="input" v-model="inputAddress" type="text" class="form-control"
                   placeholder="Введите адрес для номера дома" @keydown.prevent.down.up.enter
                   @keyup.prevent.up.down.enter="variantsNavigate" :class="{'list-open': showVariantList}"
            >
            <span v-if="inputAddress" class="ic-cross" @click="inputAddress = ''"></span>
            <ul class="crud-house-variants dropdown-menu" :class="{show: showVariantList}">
              <loader :size="1.5" v-if="isVariantsListLoading"/>
              <li v-else v-for="(variant, id) in variantsList" :key="variant.value"
                  :class="{selected: id === selectedVariantId}">
                <a @click="clickList(variant)" class="dropdown-item" v-html="variant.valueMarked"></a>
              </li>
            </ul>
          </div>
          <div class="col-12 col-md-4">
            <button :disabled="!hasHouseInAddress || isHouseDataLoaded" @click="findAddress" class="btn btn-primary"
                    type="button">
              Применить
            </button>
          </div>
        </div>

        <div class="row house-info">
          <div class="col-4">
            <label for="zipcode">Почтовый индекс</label>
            <input disabled :value="zip_code" type="text" class="form-control" id="zipcode">
          </div>

          <div class="col-4">
            <label for="kadastr">Кадастровый номер</label>
            <input v-model="kadastr" :class="{invalid:!kadastrIsValid}" @focusout="kadastrFocusout"
                   type="text" class="form-control" id="kadastr" placeholder="XX:XX:XXXXXX...">
            <span v-if="!kadastrIsValid" class="error-message">Некорректно заполненное поле</span>
          </div>

          <div class="col-4">
            <label for="build-year">Год постройки</label>
            <input v-model="year" v-mask="'####'" :class="{invalid:!yearIsValid}" @focusout="yearFocusout"
                   type="text" class="form-control" id="build-year">
            <span v-if="!yearIsValid" class="error-message">Некорректно заполненное поле</span>
          </div>
        </div>
      </div>


      <Ymap :markers="marker"></Ymap>

    </div>
    <button @click="beforeSubmitForm" :disabled="cantSubmitForm" class="btn btn-primary" type="button">Сохранить
    </button>
    <router-link class="btn btn-primary" :to="{name: 'Home'}">Отменить</router-link>
  </div>
</template>


<script>
import {mask} from 'vue-the-mask'
import {useRoute} from 'vue-router'
import useAddress from "@/composables/crudHouse/UseAddress"
import useCrudHouse from "@/composables/crudHouse/UseCrudHouse"
import Ymap from "@/components/common/Ymap";
import {nextTick} from "vue";
import Loader from "@/components/common/Loader";

export default {
  name: "CrudHouse",
  components: {Loader, Ymap},
  directives: {mask},
  setup() {
    const route = useRoute()
    return {
      ...useAddress(),
      ...useCrudHouse(route.params.houseId)
    }
  },
  data() {
    return {
      findButtonBlock: true,
      kadastrWasFocusout: false,
      yearWasFocusout: false,
      yearIsValid: true,
      kadastrIsValid: true,
      selectedVariantId: -1
    }
  },
  methods: {
    clickList({value, sign}) {
      this.findButtonBlock = true
      this.addressVariantClick({value, sign})
      nextTick(() => {
        this.$refs.input.focus()
      })
    },
    checkKadastr(val, force = false) {
      if (this.kadastrWasFocusout || force) {
        const regexp = /^(\d{1,2}:\d{1,2}:\d{6,7}:\d{1,5})+(\/\d{1,2})?$/
        this.kadastrIsValid = regexp.test(val)
      }
    },
    checkYear(val, force = false) {
      if (this.yearWasFocusout || force) {
        const regexp = /^\d{4}$/
        this.yearIsValid = regexp.test(val) && Number(val) <= Number(new Date().getFullYear())
      }
    },
    kadastrFocusout(e) {
      this.kadastrWasFocusout = true
      this.checkKadastr(e.target.value)
    },
    yearFocusout(e) {
      this.yearWasFocusout = true
      this.checkYear(e.target.value)
    },
    beforeSubmitForm() {
      this.checkYear(this.year)
      this.checkKadastr(this.kadastr)

      if (this.yearIsValid && this.kadastrIsValid) {
        this.submitForm()
      }
    },
    variantsNavigate(e) {
      if (this.selectedVariantId < 0) {
        this.selectedVariantId = 0
        return
      }

      if (e.key === 'ArrowDown') {
        if (this.selectedVariantId >= this.variantsList.length - 1) {
          this.selectedVariantId = 0
          return
        }

        this.selectedVariantId++
        return
      }

      if (e.key === 'ArrowUp') {
        if (this.selectedVariantId === 0) {
          this.selectedVariantId = this.variantsList.length - 1
          return
        }

        this.selectedVariantId--
        return
      }

      if (this.selectedVariantId >= 0 && this.selectedVariantId <= this.variantsList.length - 1)
        this.addressVariantClick(this.variantsList[this.selectedVariantId])
      nextTick(() => {
        this.$refs.input.blur()
        this.$refs.input.focus()
      })
      this.selectedVariantId = -1
    }
  },
  computed: {
    showVariantList() {
      return this.variantsList.length > 0 && !this.hasHouseInAddress || this.isVariantsListLoading
    },
    cantSubmitForm() {
      return !this.canSubmitForm || !this.kadastrIsValid || !this.yearIsValid
    }
  },
  watch: {
    year(newVal) {
      this.checkYear(newVal)
    },
    kadastr(newVal) {
      this.checkKadastr(newVal)
    }
  }
}
</script>

<style lang="scss" scoped>
.crud-house {

  .crud-house-content {
    flex-direction: row;
    margin: 2rem 0;

    .row {
      margin: 1rem 0;

      div {
        padding: 0 1rem;
      }

      div:first-child {
        padding-left: 0;
      }

      div:last-child {
        padding-right: 0;
      }

      .input-with-cross {
        position: relative;

        input {
          padding-right: 34px;

          &.list-open {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            border-bottom: 0;
          }
        }

        span {
          position: absolute;
          right: 1.5rem;
          cursor: pointer;
          height: 100%;
          top: 0;
          display: flex;
          align-items: center;
        }
      }

      ul.crud-house-variants {
        width: calc(100% - 1rem);
        border-radius: 20px;
        overflow: hidden;

        &.show {
          border-top-left-radius: 0;
          border-top-right-radius: 0;
          border-top: none;

          &:before {
            content: "";
            position: absolute;
            width: calc(100% - 40px);
            left: 20px;
            height: 1px;
            background-color: var(--common-text);
            top: 0;
          }
        }

        .selected {
          color: #1e2125;
          background-color: #e9ecef;
        }

        li .dropdown-item {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    button, input {
      width: 100%;
    }
  }

  button {
    margin-right: 10px;
  }
}

input.invalid {
  border: 1px solid red;
}

.error-message {
  color: red;
}

.crud-house-loader {
  position: absolute;
  z-index: 1;
  width: 100%;
  left: 0;
  height: 100%;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.7);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}

@media (max-width: 799px) {
  .crud-house-content {
    flex-direction: column;
  }
}

@media (max-width: 767px) {
  .crud-house {
    .crud-house-content {
      .crud-house-form {
        .address > div {
          padding-left: 0;
          padding-right: 0;

          &:first-child {
            margin-bottom: .5em;
          }
        }

        .house-info {
          flex-direction: column;

          & > div {
            width: 100%;
            padding-left: 0;
            padding-right: 0;
          }
        }
      }

      .row {

        .input-with-cross span {
          right: 14px;
        }

        ul.crud-house-variants.show {
          width: 100%;
        }
      }
    }
  }
}

@media (max-width: 450px) {
  .crud-house > .btn {
    width: 100%;

    &:last-child {
      margin-top: .5em;
    }
  }
}
</style>
